export default __webpack_public_path__ + "static/media/reparacao.77fa32cf.svg";